// extracted by css-extract-rspack-plugin
export default {"textContainer":"src-domain-components-label-and-content-column-labelAndContentColumn-module__textContainer-Rru0Yc","label":"src-domain-components-label-and-content-column-labelAndContentColumn-module__label-uJbQZA"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"textContainer\":\"src-domain-components-label-and-content-column-labelAndContentColumn-module__textContainer-Rru0Yc\",\"label\":\"src-domain-components-label-and-content-column-labelAndContentColumn-module__label-uJbQZA\"}";
        // 1793705033241
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  